import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['input', "toggleIcon"]

  toggleVisibility() {
    const type = this.inputTarget.getAttribute('type') === "password" ? "text" : "password"
    this.inputTarget.setAttribute('type', type)
    this.toggleIconTarget.classList.toggle("slash-visible")
  }
}
